import { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Divider,
  DialogActions,
  Grid,
  DialogTitle,
  Box,
} from "@material-ui/core";
import { MIContext } from "./MIContext";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
  },
  title: {
    textTransform: "capitalize",
  },
  dialog_title: {
    "& h6": {
      fontWeight: "700",
    },
  },
}));

const MIFeedbackModal = () => {
  const { isFeedback, setIsFeedback, currentSelection } = useContext(MIContext);
  const classes = useStyles();
  const [feedbackData, setFeedbackData] = useState([]);

  useEffect(() => {
    setFeedbackData(currentSelection.feedBackData || "");
  }, [currentSelection]);
  return (
    <>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={isFeedback}
        onClose={() => setIsFeedback(false)}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.dialog_title}
        >
          {currentSelection?.title || ""}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                marginTop: 10,
                borderWidth: 1,
                borderColor: "#ddd",
                borderStyle: "solid",
                padding: 16,
              }}
            >
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  <Box fontWeight="fontWeightBold">Feedback</Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {feedbackData ? (
            <>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{
                  borderWidth: 1,
                  borderColor: "#ddd",
                  borderStyle: "solid",
                  padding: "5px 16px",
                }}
              >
                <Grid item xs={12}>
                  <Typography variant="h2" style={{ color: "#320032" }}>
                    <Box>{feedbackData || "-"}</Box>
                  </Typography>
                </Grid>
              </Grid>
              <Divider />
            </>
          ) : (
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                borderWidth: 1,
                borderColor: "#ddd",
                borderStyle: "solid",
                padding: "5px 16px",
              }}
            >
              <Grid item xs={3}>
                <Typography variant="h2" style={{ color: "#232323" }}>
                  <Box>{"Record not found"}</Box>
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setIsFeedback(false)}
            disableElevation
            type="button"
            style={{ textTransform: "capitalize" }}
            variant={"contained"}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default MIFeedbackModal;
